import {
    CrewImage,
    EnterButton,
    HomeStyle,
    LoginCard,
    LoginField,
    SesiImage,
    SesiImageWrapper,
    StaticImage,
    VersionNumber,
    WrapContent,
    WrapContentLoginCard,
  } from "../../styles/Home";
  import BACKGROUNDIMAGE from "../../assets/img/backgroundImage.png";
  import SESI from "../../assets/img/sesi.png";
  import CREW from "../../assets/img/crew.png";
  import { CREW_LOGIN, HOME_LOGGED, SELECTEMAIL } from "../../core/app-urls";
  import { version } from "../../utils/constants";
  import { useNavigate } from "react-router-dom";
  import { useState } from "react";
  import { cnpj, enterpriseAuth, setCnpj } from "../../data/services/enterprise_service";
  
  export default function ForgotPassword() {
    const navigate = useNavigate();
    const [login, setLogin] = useState("");
    const [senha, setSenha] = useState("");
    const [error, setError] = useState("");
  
    const handleEnterButton = async () => {
      setCnpj(login)
      navigate(SELECTEMAIL)
    };
  
    return (
      <HomeStyle>
        <WrapContent>
          <SesiImageWrapper>
            <SesiImage src={SESI} />
            <VersionNumber>{version}</VersionNumber>
          </SesiImageWrapper>
          <h1>PORTAL DO CLIENTE</h1>
          <LoginCard>
            <WrapContentLoginCard>
              <h1>Informe o CPF ou CNPJ</h1>
              <LoginField
                placeholder="CPF/CNPJ"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
              />
              
              <EnterButton onClick={handleEnterButton}>Prosseguir</EnterButton>
              
            </WrapContentLoginCard>
          </LoginCard>
          
          
          <StaticImage src={BACKGROUNDIMAGE} />
        </WrapContent>
      </HomeStyle>
    );
  }
  